// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root .budget-page .input-wrapper {
  display: inline-block;
  display: inline-flex;
  white-space: nowrap;
  align-items: flex-start;
  flex-wrap: nowrap;
}
app-root .budget-page .input-wrapper .currency-selector-input {
  margin-right: 16px;
  position: relative;
  top: -1px;
}
app-root .budget-page .input-wrapper .currency-selector-input.no-selection select {
  color: #595959;
}
app-root .budget-page .input-wrapper .currency-selector-input select {
  width: 100%;
  text-align: center;
}
app-root .budget-page .input-wrapper > * {
  flex-grow: 0;
  flex-shrink: 0;
}
app-root .budget-page .input-wrapper em {
  display: inline-block;
  font-style: normal;
  padding: 0 0.6em;
  border-top: 1px solid;
  border-left: 1px solid;
  border-bottom: 1px solid;
  height: calc(1.5em + 18px);
  line-height: calc(1.5em + 18px);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-color: var(--border-grey);
  min-width: 42px;
}
app-root .budget-page .input-wrapper .hb-input {
  position: relative;
}
app-root .budget-page .input-wrapper .hb-input > input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
app-root .budget-page .input-wrapper .hb-input .error-message {
  transform: translateX(-50%) translateY(-0.8rem);
  width: fit-content;
  position: absolute;
}
app-root .budget-page .input-wrapper .hb-input.show-validity .error-message {
  left: calc(50% - 1em);
  transform: translateY(0) translateX(-50%);
}
app-root .budget-page p.caption {
  margin-top: 20px;
}
app-root section.BUDGET_GUIDANCE_BOX_POSITION {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: fit-content;
}
app-root section.BUDGET_GUIDANCE_BOX {
  padding: 4px 15px;
  background: #262626;
  border-radius: 5px;
}
app-root .BUDGET_GUIDANCE_TEXT {
  color: white;
  font-size: 16px;
  font-weight: 700;
}
app-root .NON_MOBILE_BUDGET_GUIDANCE {
  color: #262626;
  font-weight: 500;
  display: none;
}
@media (min-width: 768px) {
  app-root .NON_MOBILE_BUDGET_GUIDANCE {
    display: block;
  }
}
app-root .MOBILE_BUDGET_GUIDANCE {
  color: #262626;
  font-weight: 500;
  padding-top: 5;
  display: block;
}
@media (min-width: 768px) {
  app-root .MOBILE_BUDGET_GUIDANCE {
    display: none;
  }
}
app-root section.budget-notes .hb-text-area {
  width: 100%;
}
@media (min-width: 900px) {
  app-root section.budget-notes .hb-text-area {
    width: 72%;
  }
}
app-root section.budget-notes label {
  margin-top: 32px;
  margin-bottom: 10px;
}
@media (min-width: 900px) {
  app-root section.budget-notes label {
    margin-top: 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Views/FormSteps/Budget/BudgetInput.less"],"names":[],"mappings":"AAEA;EAGM,qBAAA;EAEA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAJN;AAJA;EAWQ,kBAAA;EACA,kBAAA;EACA,SAAA;AAJR;AAMQ;EACE,cAAA;AAJV;AAZA;EAoBU,WAAA;EACA,kBAAA;AALV;AAhBA;EAyBQ,YAAA;EACA,cAAA;AANR;AApBA;EA8BQ,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BAAA;EACA,2BAAA;EACA,8BAAA;EACA,gCAAA;EACA,eAAA;AAPR;AAlCA;EA4CQ,kBAAA;AAPR;AArCA;EA8CU,yBAAA;EACA,4BAAA;AANV;AAzCA;EAmDU,+CAAA;EACA,kBAAA;EACA,kBAAA;AAPV;AASQ;EAEI,qBAAA;EACA,yCAAA;AARZ;AAlDA;EAgEM,gBAAA;AAXN;AArDA;EAqEI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAbJ;AA3DA;EA4EI,iBAAA;EACA,mBAAA;EACA,kBAAA;AAdJ;AAhEA;EAkFI,YAAA;EACA,eAAA;EACA,gBAAA;AAfJ;AArEA;EAwFI,cAAA;EACA,gBAAA;EACA,aAAA;AAhBJ;AAiBI;EAAA;IACE,cAAA;EAdJ;AACF;AA/EA;EAiGI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAfJ;AAgBI;EAAA;IACE,aAAA;EAbJ;AACF;AA1FA;EA4GM,WAAA;AAfN;AAgBM;EAAA;IACE,UAAA;EAbN;AACF;AAlGA;EAkHM,gBAAA;EACA,mBAAA;AAbN;AAcM;EAAA;IACE,gBAAA;EAXN;AACF","sourcesContent":["@import '../../../Styles/mediaQueries.less';\n@import '../../../Styles/colours.less';\napp-root {\n  .budget-page {\n    .input-wrapper {\n      display: inline-block;\n      white-space: nowrap;\n      display: inline-flex;\n      white-space: nowrap;\n      align-items: flex-start;\n      flex-wrap: nowrap;\n\n      .currency-selector-input {\n        margin-right: 16px;\n        position: relative;\n        top: -1px;\n\n        &.no-selection select {\n          color: @border-grey;\n        }\n\n        select {\n          width: 100%;\n          text-align: center;\n        }\n      }\n      > * {\n        flex-grow: 0;\n        flex-shrink: 0;\n      }\n\n      em {\n        display: inline-block;\n        font-style: normal;\n        padding: 0 0.6em;\n        border-top: 1px solid;\n        border-left: 1px solid;\n        border-bottom: 1px solid;\n        height: calc(1.5em + 18px);\n        line-height: calc(1.5em + 18px);\n        border-top-left-radius: 4px;\n        border-bottom-left-radius: 4px;\n        border-color: var(--border-grey);\n        min-width: 42px;\n      }\n      .hb-input {\n        position: relative;\n        > input {\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n\n        .error-message {\n          transform: translateX(-50%) translateY(-0.8rem);\n          width: fit-content;\n          position: absolute;\n        }\n        &.show-validity {\n          .error-message {\n            left: calc(50% - 1em);\n            transform: translateY(0) translateX(-50%);\n          }\n        }\n      }\n    }\n    p.caption {\n      margin-top: 20px;\n    }\n  }\n\n  section.BUDGET_GUIDANCE_BOX_POSITION {\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    width: fit-content;\n  }\n\n  section.BUDGET_GUIDANCE_BOX {\n    padding: 4px 15px;\n    background: #262626;\n    border-radius: 5px;\n  }\n\n  .BUDGET_GUIDANCE_TEXT {\n    color: white;\n    font-size: 16px;\n    font-weight: 700;\n  }\n\n  .NON_MOBILE_BUDGET_GUIDANCE {\n    color: #262626;\n    font-weight: 500;\n    display: none;\n    @media (min-width: 768px) {\n      display: block;\n    }\n  }\n\n  .MOBILE_BUDGET_GUIDANCE {\n    color: #262626;\n    font-weight: 500;\n    padding-top: 5;\n    display: block;\n    @media (min-width: 768px) {\n      display: none;\n    }\n  }\n\n  section.budget-notes {\n    .hb-text-area {\n      width: 100%;\n      @media @landscapeTabletUp {\n        width: 72%;\n      }\n    }\n    label {\n      margin-top: 32px;\n      margin-bottom: 10px;\n      @media @landscapeTabletUp {\n        margin-top: 48px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
